import ProductCard from './ProductCard';

function ProductList({ title, products, cartById, onAdd, onRemove }) {
  return (
    <main className="right">
      <div className="sectionTitle">
        <div className="sectionName">{title}</div>
        <div className="sectionCount">{products.length} 个菜品</div>
      </div>

      <div className="list">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            quantity={cartById[product.id] ?? 0}
            onAdd={() => onAdd(product.id)}
            onRemove={() => onRemove(product.id)}
          />
        ))}
      </div>
    </main>
  );
}

export default ProductList;
